import type { SearchInField } from '../useData';

/** Default email quick-search fields (attachments and body are opt-in). */
export const DEFAULT_EMAIL_SEARCH_IN_FIELDS: readonly SearchInField[] = [
  'sender',
  'recipients',
  'subject',
];

export function defaultEmailSearchInSet(): Set<SearchInField> {
  return new Set(DEFAULT_EMAIL_SEARCH_IN_FIELDS);
}

export function isDefaultEmailSearchIn(fields: Set<SearchInField>): boolean {
  if (fields.size !== DEFAULT_EMAIL_SEARCH_IN_FIELDS.length) return false;
  return DEFAULT_EMAIL_SEARCH_IN_FIELDS.every((field) => fields.has(field));
}
